import { Link, Text } from "basis";

export const JointAccountContent = () => (
  <Text testId="joint-account-content">
    Due to the status of your account, your payment notification preferences are
    not available.
    <br />
    Please contact Latitude{" "}
    <Link href="/contact" newTab={false}>
      customer support
    </Link>
    .
  </Text>
);
